import React from "react";
import "./footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <div className="background-section"></div>
    </div>
  );
};

export default Footer;
